import React, { useEffect, useState } from 'react';
import {
  Container,
  FilterButton,
  FilterButtonContent,
} from './MobileFilters.styled';
import { FilterListOutlinedIcon } from '../../../assets';
import { SelectType, TextSize } from '../../../models/enum';
import { useRouter } from 'next/router';
import { Section } from '../../../models/domain/interfaces';
import { SortingSelect } from '../../sorting-select/SortingSelect';

interface IProps {
  sections: Section[];
  handleFilterButtonClick: () => void;
  translations: any;
  filterSections: Section[];
}

const MobileFilters: React.FC<IProps> = ({
  sections,
  handleFilterButtonClick,
  translations,
  filterSections,
}) => {
  const [sorting, setSorting] = useState(
    filterSections?.[0]?.voices?.find?.(({ active }: any) => {
      return active;
    })?.link ||
      filterSections?.[0]?.voices?.[0]?.link ||
      ''
  );
  const router = useRouter();

  useEffect(() => {
    setSorting(
      filterSections?.[0]?.voices?.find?.(({ active }: any) => {
        return active;
      })?.link ||
        filterSections?.[0]?.voices?.[0]?.link ||
        ''
    );
  }, [filterSections, router.asPath]);

  return (
    <>
      {sections && sections.length > 0 && (
        <Container>
          {sections && sections.length > 0 ? (
            <FilterButton onClick={handleFilterButtonClick}>
              <FilterListOutlinedIcon />
              <FilterButtonContent>
                {translations.pages.category.main.filterMenu.buttonLabel}
              </FilterButtonContent>
            </FilterButton>
          ) : (
            <></>
          )}
          {sections && sections.length > 0 ? (
            <SortingSelect
              currentValue={sorting}
              type={SelectType.secondary}
              textSize={TextSize.small}
              onChange={(val: any) => {
                const link = val as string;
                setSorting(link);
                router.push(link);
              }}
              options={filterSections}
            />
          ) : (
            <></>
          )}
        </Container>
      )}
    </>
  );
};

export default MobileFilters;
